/**
 * @generated SignedSource<<7daee299ad8944274db1608f94e0ae78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportPeriod = {
  endDate?: string | null;
  startDate?: string | null;
};
export type TransactionDrilldownQuery$variables = {
  reportId: string;
  reportPeriod?: ReportPeriod | null;
  transactionProps?: any | null;
};
export type TransactionDrilldownQuery$data = {
  readonly reportById: {
    readonly generalLedgerTransactions: any | null;
  } | null;
};
export type TransactionDrilldownQuery = {
  variables: TransactionDrilldownQuery$variables;
  response: TransactionDrilldownQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reportPeriod"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transactionProps"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reportId"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "reportPeriod",
          "variableName": "reportPeriod"
        },
        {
          "kind": "Variable",
          "name": "transactionProps",
          "variableName": "transactionProps"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "generalLedgerTransactions",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionDrilldownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionDrilldownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "reportById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6487319fc08bd57cb50f51ce7e747c5",
    "id": null,
    "metadata": {},
    "name": "TransactionDrilldownQuery",
    "operationKind": "query",
    "text": "query TransactionDrilldownQuery(\n  $reportId: ID!\n  $reportPeriod: ReportPeriod\n  $transactionProps: JSON\n) {\n  reportById(id: $reportId) {\n    generalLedgerTransactions(input: {reportPeriod: $reportPeriod, transactionProps: $transactionProps})\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a389938c2484a0ec0381cad2959a7c5";

export default node;
